export const myInfoHdbTypes = [
  '1-ROOM FLAT (HDB)',
  '2-ROOM FLAT (HDB)',
  '3-ROOM FLAT (HDB)',
  '4-ROOM FLAT (HDB)',
  '5-ROOM FLAT (HDB)',
  'EXECUTIVE FLAT (HDB)',
  'STUDIO APARTMENT (HDB)',
]
